module.exports = __webpack_public_path__ + "img/tiktok-solid.7458ea26.svg";